import React from 'react';
import ScoreItem from '../ScoreItem';
import {ProspectPool, ProspectPoolScore, ProspectScoreCustomizeItem} from 'api';

interface CustomScoreItemsProps {
  prospectPool: ProspectPool;
  prospectScore: ProspectPoolScore;
  settingItem: ProspectScoreCustomizeItem;
}

const CustomScoreItems: React.FC<CustomScoreItemsProps> = ({
  prospectPool,
  prospectScore,
  settingItem,
}) => {
  const customizeItem = settingItem?.poolProspectCustomizeItem;
  const customizeItemId = customizeItem?.id;

  const customizeItemScore =
    prospectScore?.prospectPoolCustomizeItemScores?.find(
      (score) => score?.poolProspectCustomizeItem?.id === customizeItemId,
    );

  const customizeItemDate = prospectPool?.prospect?.customizeItemDates?.find(
    (item) => item.poolProspectCustomizeItemId === customizeItemId,
  );

  const target = settingItem?.weight !== 0 && customizeItemDate?.value != null;

  const hasSetting =
    !!settingItem?.clientProspectScoreSettingCustomizeItemDates?.length;

  return (
    <ScoreItem
      key={customizeItemId}
      title={customizeItem?.name}
      score={Math.round((customizeItemScore?.score ?? 0) * 0.6)}
      target={target}
      hasSetting={hasSetting}
    />
  );
};

export default CustomScoreItems;
